import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicUpload from "@/components/picUpload/index.vue";
import questionSettingTemplate from "./questionSettingTemplate.vue";
let cascade = class cascade extends Vue {
  constructor() {
    super(...arguments);
    this.postForm = {
      title: "请选择以下选项",
      required: "1"
    };
    this.rules = {
      title: [{
        required: true,
        min: 0,
        max: 15,
        message: "请输入题目标题",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], cascade.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], cascade.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], cascade.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], cascade.prototype, "watchPostForm", null);
cascade = __decorate([Component({
  name: "cascade",
  components: {
    PicUpload,
    questionSettingTemplate
  },
  filters: {}
})], cascade);
export default cascade;